import yup from 'utils/yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState, useContext, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { IAgentUserForList } from 'domain/entities/AgentUser/AgentUser';
import { AgentMemberQuery } from 'interfaceAdapter/queries/AgentMember';
import { InviteAgentUserRepository } from 'interfaceAdapter/repositories/InviteAgentUser';
import { useModal } from 'ui/components/screens/modals/useModal';
import { agentUserContext } from 'application/contexts/useAgentUser';

const schema = yup
    .object({
        email: yup.string().email().required(),
    })
    .required();

type inviteForm = yup.InferType<typeof schema>;

export const useMember = () => {
    const diContainer = useContext(diContainerContext);
    const agentMemberQuery = diContainer.resolve(AgentMemberQuery);
    const inviteAgentUserRepository = diContainer.resolve(InviteAgentUserRepository);
    const [memberList, setMemberList] = useState<IAgentUserForList[]>([]);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const inviteModal = useModal();
    const needProfileModal = useModal();
    const { user } = useContext(agentUserContext);

    const {
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm<inviteForm>({
        resolver: yupResolver(schema),
        mode: 'onChange',
        defaultValues: {
            email: '',
        },
    });

    useEffect(() => {
        const fetchData = async () => {
            const data = await agentMemberQuery.fetchList();
            setMemberList(data);
        };
        fetchData();
    }, []);

    const invite = handleSubmit(async (data) => {
        await inviteAgentUserRepository.post(data.email);
        inviteModal.closeModal();
        setShowSnackbar(true);
    });

    return { memberList, showSnackbar, inviteModal, needProfileModal, errors, user, setShowSnackbar, setValue, invite };
};
